<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="content">
      <div class="search-wrap">
        <div class="search-wrap-title">全量异常电站</div>
        <div class="search-wrap-btn">
          <el-button size="small" type="primary" @click="handleAllStation">复制全量电站</el-button>
        </div>
      </div>
      <div class="search-group" v-for="item in pileInfoData" :key="item.stationId">
        <div class="search-title">
          <span class="city-name">{{ item.cityName }}</span>
          <span>（</span>
          <span class="city-count">{{ item.list.length }}</span>
          <span>)</span>
          <span class="city-copy">
            <el-button size="small" type="primary" @click="handleCityStation(item.list)">
              复制电站
            </el-button>
          </span>
        </div>
        <div class="search-info">
          <div class="search-info-card" v-for="(item, index) in item.list" :key="index">
            <div class="image img0"><span>全站异常</span></div>
            <div class="value">
              <div class="station-name" :title="item.stationName">{{ item.stationName }}</div>
              <div class="code">
                <span>{{ item.stationCode }}</span>
                <span class="copy" @click="copyGunCode(item.stationCode)"></span>
              </div>
              <div class="pile-number">桩数：{{ item.pileTotalCount }}</div>
              <div class="pile-location">位置：{{ item.detailAddress }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </scroll-layout>
</template>
<script>
  import { workbench, treeUtils } from '@/service/apis';

  export default {
    data() {
      return {
        searchParams: {
          cityIds: [],
        },
        pileInfoData: [],
        addressData: [], // 省市区
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcCascader',
            key: 'cityIds',
            label: '城市',
            placeholder: '请选择城市',
            configSet: {
              label: 'name',
              value: 'id',
              children: 'subNodes',
            },
            options: this.addressData,
          },
        ];
      },
    },
    created() {
      this.queryMonitorPage();

      this.requestGetDistrict();
    },
    methods: {
      /**
       * 获取区域数据
       */
      requestGetDistrict() {
        treeUtils
          .getDistrict({ level: 3 })
          .then(res => {
            this.addressData = res.districts;
          })
          .catch(err => {
            console.log(err);
          });
      },

      // 电桩监控分页查询
      queryMonitorPage() {
        // 城市选择
        if (
          this.searchParams.cityIds &&
          Array.isArray(this.searchParams.cityIds) &&
          this.searchParams.cityIds.length > 0
        ) {
          [, this.searchParams.cityId] = this.searchParams.cityIds;
          this.searchParams.cityId = `${this.searchParams.cityId}`;
        } else {
          this.searchParams.cityId = null;
        }

        const params = {
          ...this.searchParams,
          gunStatus: this.gunStatus,
        };
        delete params.cityIds;
        workbench.queryAllOfflineStationList(params).then(res => {
          this.pileInfoData = res;
        });
      },

      // 复制全部电站
      handleAllStation() {
        let result = [];
        this.pileInfoData.forEach(item => {
          result = result.concat(this.handleCityData(item.list));
        });
        this.$copyText(result.join('，'))
          .then((e, err) => {
            if (e) {
              this.$message.success('已复制到剪切板中');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },

      handleCityStation(list) {
        const result = this.handleCityData(list);
        this.$copyText(result.join('，'))
          .then((e, err) => {
            if (e) {
              this.$message.success('已复制到剪切板中');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },

      // 处理单个城市数据
      handleCityData(list) {
        const cityData = [];
        list.forEach(item => {
          cityData.push(item.stationName);
        });
        return cityData;
      },
      // 复制
      copyGunCode(stationCode) {
        this.$copyText(stationCode)
          .then((e, err) => {
            if (e) {
              this.$message.success('复制成功');
            }
            if (err) {
              this.$message.error('复制失败');
            }
          })
          .catch(error => {
            console.log('error', error);
          });
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        Object.assign(this.searchParams, form);
        this.queryMonitorPage();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .content {
    // background: #ffffff;
    padding-bottom: 20px;

    .search-wrap {
      display: flex;
      justify-content: space-between;
      padding: 0px 25px;
      .search-wrap-title {
      }
      .search-wrap-btn {
      }
    }

    .search {
      display: flex;
      justify-content: flex-start;
      padding: 23px 0px 22px 27px;
      &-status {
        width: 128px;
        height: 80px;
        background: #f2f9ff;
        border: 1px solid rgba(77, 140, 253, 0.17);
        display: flex;
        flex-direction: column;
        .num {
          margin-top: 15px;
          font-weight: 600;
          font-size: 22px;
          line-height: 30px;
          text-align: center;
        }
        .text {
          font-weight: 500;
          font-size: 12px;
          color: #4a4a4a;
          line-height: 17px;
          text-align: left;
          text-align: center;
        }
      }
      .active {
        background: #4d8cfd;
        box-shadow: 1px 1px 4px 1px rgba(94, 94, 94, 0.09);
        .num {
          color: #ffffff !important;
        }
        .text {
          color: #ffffff;
        }
      }
      .status-1 {
        .num {
          color: #15c350;
        }
      }
      .status-2 {
        .num {
          color: #005bff;
        }
      }
      .status-3 {
        .num {
          color: #ff0000;
        }
      }
      .status-4 {
        .num {
          color: #fa6400;
        }
      }
    }

    .search-group {
      padding-left: 27px;
      .search-title {
        color: #000000;
        font-size: 12px;
        .city-name {
          font-size: 14px;
        }
        .city-count {
          color: red;
        }
        .city-copy {
          margin-left: 20px;
        }
        margin-bottom: 10px;
      }
    }

    .search-info {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      &-card {
        width: 310px;
        height: 158px;
        margin-right: 39px;
        margin-bottom: 36px;
        background: #ffffff;
        box-shadow: 1px 1px 4px 1px rgba(66, 66, 66, 0.09);
        border-radius: 4px;
        display: flex;
        position: relative;
        .image {
          margin-top: 40px;
          width: 68px;
          height: 76px;
          background: #fa6400;
          text-align: center;
          margin-left: 10px;
          flex: none;
        }
        .img0 {
          background: url('~@/assets/images/staging/offline.png') no-repeat 100%;
          span {
            font-size: 10px;
            line-height: 13px;
            position: relative;
            top: 50%;
            color: #ffff76;
          }
        }
        .img1 {
          background: url('~@/assets/images/staging/fault.png') no-repeat 100%;
          span {
            font-size: 10px;
            line-height: 13px;
            position: relative;
            top: 50%;
            color: #ffffff;
          }
        }
        .img2 {
          background: url('~@/assets/images/staging/Idle.png') no-repeat 100%;
          span {
            line-height: 21px;
            font-size: 16px;
            position: relative;
            top: 27px;
            color: #ffffff;
          }
        }
        .img3 {
          background: url('~@/assets/images/staging/charging.png') no-repeat 100%;
          span {
            line-height: 21px;
            font-size: 16px;
            position: relative;
            top: 27px;
            color: #ffffff;
          }
        }
        .value {
          color: #000000;
          text-align: left;
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          box-sizing: border-box;
          padding-right: 10px;
          padding-left: 10px;
          overflow: hidden;

          .code {
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            margin-top: 8px;
            display: flex;
            justify-content: flex-start;
            cursor: pointer;
            .copy {
              visibility: hidden;
              margin-left: 6px;
              width: 14px;
              background: url('~@/assets/images/staging/copy.png') no-repeat 100%;
            }
            &:hover {
              .copy {
                visibility: visible;
              }
            }
          }
          .station-name {
            font-weight: 500;
            font-size: 11px;
            line-height: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .pile-number {
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            margin-top: 8px;
          }
          .pile-location {
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            margin-top: 8px;
          }
        }
        .pileType {
          width: 43px;
          height: 18px;
          background: #000000;
          font-weight: 600;
          font-size: 10px;
          color: #ffffff;
          line-height: 18px;
          text-align: center;
          border-radius: 0px 0px 0px 6px;
          position: relative;
          right: -25px;
          top: 0;
        }
        .to-be-filled {
          width: 80px;
          height: 40px;
          position: relative;
          right: 0;
          bottom: 0;
        }
        .exchange {
          background: #0091ff !important;
        }
      }
    }
  }
</style>
